import { Card, CardBody } from '@chakra-ui/react';
import ArtistGrid from 'components/Artist/ArtistGrid/ArtistGrid';
import { useArtists } from 'hooks/queries/useArtists';
import { useNavigate } from 'react-router-dom';
import { NavigationService } from 'services';
import { ArtistModel } from 'models';

export default function DashboardArtistGridCard() {
  const { data: artists = [], isLoading } = useArtists();
  const navigate = useNavigate();

  const handleArtistClick = (artist: ArtistModel) => {
    navigate(NavigationService.getArtistDetailsPath(artist.id, artist.name));
  };

  return (
    <Card w="100%">
      <CardBody>
        <ArtistGrid
          artists={artists}
          isLoading={isLoading}
          gridDisplay
          onArtistCardClick={handleArtistClick}
          showFilters={false}
          showSort={false}
          gridMaxHeight={600}
        />
      </CardBody>
    </Card>
  );
}
